import { forwardRef, useImperativeHandle, useRef } from "react";
import { TextBox } from "@etframework/ui.components";
import createBoardImg from "../../content/img/create-board.svg";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

export const CreateBoardForm = forwardRef(({ id, initState }, ref) => {
  const { t } = useTranslation(["CreateBoardModal", "AccessModal", "Shared"]);

  const nameId = id + "_name-input";
  const descriptionId = id + "_description-input";

  const nameRef = useRef(null);
  const descriptionRef = useRef(null);

  const getValue = useCallback(() => {
    return {
      Name: nameRef.current?.getValue(),
      Description: descriptionRef.current?.getValue(),
    };
  }, []);

  const validate = useCallback(() => {
    const nameValue = nameRef.current?.getValue?.();
    if (!nameValue) {
      nameRef.current?.setError(t("Required"));
      nameRef.current?.setShowError(true);
      return false;
    } else {
      return true;
    }
  }, [t]);

  useImperativeHandle(
    ref,
    () => ({
      getValue,
      validate,
    }),
    [getValue, validate]
  );

  return (
    <div id={id} className="create-board-modal-content general-board-info">
      <div className="picture-container">
        <img src={createBoardImg} height={145} />
        <p className="picture-message">{t("CreateBoardPicture")}</p>
      </div>
      <div className="create-board-form-fields">
        <TextBox
          autoFocus
          name="Name"
          className="mb-4 position-relative"
          ref={nameRef}
          labelText={t("BoardName")}
          id={nameId}
          value={initState?.Name}
          labelColor={"#000"}
          autocomplete="off"
          boldLabel={false}
          focus={() => nameRef.current.setShowError(false)}
        />
        <TextBox
          name="Description"
          ref={descriptionRef}
          labelText={
            <>
              {t("Description")}
              <span className="label-optional">{t("Optional")}</span>
            </>
          }
          id={descriptionId}
          value={initState?.Description}
          multiline
          type="text"
          autocomplete="off"
          labelColor={"#000"}
          boldLabel={false}
          placeholder={t("DescriptionPlaceholder")}
          htmlAttributes={{ rows: "5" }}
        />
        <p>
          <span className="fw-600">{t("ExpertTip")}: </span>
          {t("CreateBoardTip")}
        </p>
      </div>
    </div>
  );
});
